module.exports = __webpack_public_path__ + "static/media/Microsoft.b379068e.webp";